export default __webpack_public_path__ + "static/media/eatingtimes_4@3x.fc526109.jpg";